import {
    USER_LIST_REQUEST,
    USER_LIST_SUCCESS,
    USER_LIST_FAIL,
    USER_LIST_RESET,

    USER_DELETE_REQUEST,
    USER_DELETE_SUCCESS,
    USER_DELETE_FAIL,
} from '../constants/userConstants';

import { axiosAuthed } from "../auth/createAuthedAxios.ts";


export const listUsers = () => async (dispatch) => {
    try {
        dispatch({ type: USER_LIST_REQUEST });
        const { data } = await axiosAuthed.get(`${process.env.REACT_APP_HOST_IP}admin/users`);
        dispatch({ type: USER_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: USER_LIST_FAIL,
            payload: error.response?.data?.detail ?? error.message,
        });
    }
};


export const deleteUser = (clerkUserId) => async (dispatch) => {
    try {
        dispatch({ type: USER_DELETE_REQUEST });
        await axiosAuthed.delete(`${process.env.REACT_APP_HOST_IP}admin/users/delete/${clerkUserId}`);
        dispatch({ type: USER_DELETE_SUCCESS });
        dispatch(listUsers());
    } catch (error) {
        dispatch({
            type: USER_DELETE_FAIL,
            payload: error.response?.data?.detail ?? error.message,
        });
    }
};
